import React, { useEffect, useState } from 'react';
import { TiArrowSortedUp } from "react-icons/ti";
import { TiArrowSortedDown } from "react-icons/ti";

const replaceStr = (value)=> {
  if(typeof(value) === "number"){
    return value
  }
  const cleanedValue = String(value).replace('%', '');
  return Number(cleanedValue);
}

const ComparisonCardsWidget = ({ data, heading, size, option=null }) => {
  const [ cards, setCards ] = useState([]);
  const [ previousCards, setPreviousCards ] = useState([])

  useEffect(() => {
    if(data?.current || data?.previous){
      setCards(data?.current);
      setPreviousCards(data?.previous);
    }
  }, [data]);
  
  return (
    <div className={`col row mx-0 mt-2 px-1 ${size}`}>
    {heading
      ? <h4 className="mb-2 px-2">{heading}</h4>
      : ''
    }
      <div className='row mx-0 px-0 flex-wrap dashboard__card-container'>
        {cards?.length ? cards.map((card,index) => (
          <div key={card.name} className='col-3 p-0' >
            <div className='col py-2 flex-nowrap dashboard__card_view' style={{margin:"0 0.4rem"}} >
              <div className='border border-0 border-1 border-bottom mb-1 px-2'>
                <div title={card.title} className='text-capitalize lg-text mb-0'>{card.name}</div>
              </div>
              <div className='col px-2 pt-1'>
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='d-block'>
                    <p className='font-weight-bold xslg-text mb-0'>{card.value?.toLocaleString()}</p>
                    {previousCards && (
                      <>
                        <p className='table-text mb-0'><span className='print-text text-capitalize'>Last {option}: </span>{previousCards[index]?.value}</p>
                        <p className='table-text mb-0'>
                          {replaceStr(card.value) > replaceStr(previousCards[index]?.value) ? <span className='text-primary dashboard_percent'><TiArrowSortedUp className = "dashboard_card_up"/> {replaceStr(previousCards[index]?.value) > 0 ? (((replaceStr(card.value) - replaceStr(previousCards[index]?.value))/replaceStr(previousCards[index]?.value))*100).toFixed(1) : 0 }%  </span> : <span className='text-danger dashboard_percent'><TiArrowSortedDown className="dashboard_card_down"/>  {replaceStr(card.value) > 0 ? (100 - ((replaceStr(card.value)/replaceStr(previousCards[index]?.value))*100)).toFixed(1) : 0 }% </span>}
                        </p>
                      </>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        )) : <div className='d-flex justify-content-center align-items-center xlg-text' style={{height:"16rem",borderRadius:"0.75rem"}}>No Data</div>}
      </div>
    </div>
  )
}

export default ComparisonCardsWidget